export const useRecentStore = defineStore('recent', () => {
  const items = ref<Array<any>>([])
  const limit = 47

  const add = (payload: Number) => {
    const exists = items.value.find((row: any) => {
      if (typeof row === 'object') {
        return row.cId === payload // Backwards compatibility
      }
      if (typeof row === 'number') {
        return row === payload
      }

      return false
    })

    if (!exists) {
      if (items.value.length - 1 > limit) {
        items.value.splice(limit)
      }
      items.value.unshift(payload)
    }
  }

  const clear = () => {
    items.value = []
  }
  return { add, clear, items }
}, {
  persistedState: {
    persist: true
  }
})
